import { InputCarInsurance, InputProps } from '../Inputs/Input';

export interface FormInputProps extends Omit<InputProps, 'error'> {
  label: string;
  error?: string;
  hint?: string;
  value: string;
}

export const FormInput: React.FC<FormInputProps> = ({
  label,
  error,
  hint,
  value,
  ...restProps
}) => {
  const showHint = Boolean(hint) && !error?.length && !value.length;

  return (
    <div className="flex grow flex-col gap-1">
      <p className="font-medium text-gray-800 text-base">{label}</p>
      <InputCarInsurance
        error={Boolean(error)}
        isBold
        backgroundColor="bg-white"
        value={value}
        {...restProps}
      />
      {showHint && <p className="font-medium text-gray-800 text-xs">{hint}</p>}
      {!!error && <p className="font-normal text-red-800 text-sm">{error}</p>}
    </div>
  );
};
